import { validateServerData } from '@wwt/core/admin'
import { OfferResponseDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'
import { offerResponseDtoToOfferAdapter } from '@wwt/shared/utils/extractOffer/extractOfferFromSearchResponse/offerResponseDtoToOfferAdapter'

import { api } from '@/shared/api/client.ts'
import * as Errors from '@/shared/lib/errors'

export const validateOfferQuery = async (
	savedOfferId: Offer['IDs']['wwtOfferId'],

	// NOTE: signal is not required for validation, because we can(and should) use it in mutations
	signal?: AbortSignal
) => {
	const response = await api()
		.options({ signal })
		.get(`/v1/offers/validate/${savedOfferId}`)
		.notFound(error => {
			throw new Errors.NotFoundError('Not found', error.json)
		})
		.json()

	return offerResponseDtoToOfferAdapter(
		// XXX: In apidog this is a `OfferValidationResponseDto`, but in a swagger
		// it's `OfferDto`(OfferResponseDto)
		// So for now we use OfferResponseDto
		await validateServerData(response, OfferResponseDto, 'Validate an offer')
	)
}
